import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-4 pt-1 d-flex justify-content-between" }

import Dialog from "@/components/ui/Modal/Dialog/Dialog.vue";
import {computed, PropType, ref} from "vue";
import {ILocationPackage} from "@/api/services/packages/esim/location-packages/types";
import SelectPackage from "@/components/User/SelectPackage.vue";
import AppButton from "@/components/ui/Buttons/AppButton.vue";
import {api} from "@/api/Api";
import {useStore} from "vuex";
import {IApiResponse} from "@/api/interfaces/IApi";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditUserEsim',
  props: {
  opened: {type: Boolean, default: false},
  canCancel: {type: Boolean, default: false},
  plans: {
    type: Object as PropType<ILocationPackage[]>,
    required: true
  },
  currentPackage: {
    type: Object as PropType<number | null>
  },
  userId: {
    type: Number as PropType<number>,
    required: true
  },
  profileId: {
    type: Number as PropType<number | null>,
    required: true
  }
},
  emits: {
  hide: null,
  changePackage: null,
  refetch: null
},
  setup(__props, { emit }) {

const props = __props;

const currentEsim = ref<number | null>(null)

function changePackage(id: number) {
  currentEsim.value = id
}

const store = useStore()

const validation = computed<boolean>(() => {
  return currentEsim.value !== null
})





const loading = ref<boolean>(false)

async function baseRequestHandler(promise: Promise<IApiResponse> ) {
  try {
    const {success, message} = await promise;
    if (!success) {
      throw new Error(message);
    }
    await store.dispatch("showSuccessNotification", 'Success');
    emit('refetch');
    emit('hide');
  } catch (e: any) {
    await store.dispatch("showErrorNotification", e.message);
  }
}

async function editHandler(): Promise<void> {
  const data = {
    userId: props.userId,
    packageId: currentEsim.value,
    profileId: props.profileId
  }
  console.table({editSubmit: data})
  if (!props.profileId || !currentEsim.value) {
    return
  }

  const func: Promise<IApiResponse> = api.setPackageForUser(props.profileId, currentEsim.value, props.userId)
  await baseRequestHandler(func)
}

async function deleteHandler(): Promise<void> {
  const data = {
    userId: props.userId,
    profileId: props.profileId
  }
  console.table({deleteSubmit: data})
  if (!props.profileId) {
    return
  }

  const func: Promise<IApiResponse> = api.deleteEsimForUser(props.userId, props.profileId)
  await baseRequestHandler(func)
}

function hide() {
  emit('hide')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Dialog, _mergeProps({
    title: "Set package",
    opened: __props.opened
  }, _ctx.$attrs, { onHide: hide }), {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createVNode(SelectPackage, {
          plans: __props.plans,
          onChangePackage: changePackage
        }, null, 8, ["plans"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(AppButton, {
            type: "danger",
            size: "lg",
            loading: loading.value,
            onClick: deleteHandler
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Delete current ")
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(AppButton, {
            type: "secondary",
            size: "lg",
            loading: loading.value,
            onClick: editHandler,
            disabled: !_unref(validation)
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Set package ")
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ], 32)
    ]),
    _: 1
  }, 16, ["opened"]))
}
}

})